import { MemberImportSessions } from '../components/memberImportSessions';

export const MemberImportSessionsPage = () => <MemberImportSessions />;
